import { graphql, useStaticQuery } from "gatsby"

export default function useInfoTransversal() {
  const result = useStaticQuery(graphql`
  query infoTransversal {
    allContentfulPequeninTransversal(
      filter: {titulo: {eq: "Transversal"}}
    ) {
      nodes {
        node_locale
        logo {
          description
          file {
            url
          }
        }
        logo2 {
          description
          file {
            url
          }          
        }
        favicon {
          description
          file {
            url
          }          
        }
        logoClubPequenin {
          description
          file {
            url
          }          
        }
      }
    }
  }
  
  `)
  const allInfoTransversal =  
    result.allContentfulPequeninTransversal.nodes
  const countryInfoTransversal = allInfoTransversal.filter(
    e => e.node_locale === process.env.LOCALE
  )
  
  return { allInfoTransversal, countryInfoTransversal }
}
